var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonItem',{attrs:{"title":_vm.textField,"desc":_vm.deptNames,"img-url":_vm.complete(("user/photo.htm?uid=" + _vm.idField)),"show-checkbox":_vm.showCheckbox}})}
var staticRenderFns = []

export { render, staticRenderFns }